import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import cover from '../../../assets/no-sections.svg';

const useStyles = makeStyles(({ spacing, palette }: Theme) => ({
  container: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  text: {
    color: palette.neutral[100],
    marginTop: spacing(4),
    fontSize: '1.125rem',
  },
}));

export const NoContent = (): JSX.Element => {
  const styles = useStyles();

  return (
    <div className={styles.container}>
      <img src={cover} alt="Não há armários" height="60%" />
      <div className={styles.text}>Não há armários cadastrados...</div>
    </div>
  );
};

export default NoContent;
